import React, { useEffect, useState } from "react";

import { CloseOutline } from "react-ionicons";
import LoaderMaster from "../Loaders/Loaders";
import { Box, FormControl, InputLabel, MenuItem, Select, TextareaAutosize } from "@mui/material";
import { CircleSharp } from "@mui/icons-material";
import swal from "sweetalert";
import { postApiPrivate } from "../../api";

const getReasonText = (reasonCode) => {
    switch(reasonCode) {
        case 'provider_unavailability': return 'Provider Unavailability';
        case 'product_unavailability': return 'Product Unavailability';
        case 'schedule_disagreement': return 'Schedule Disagreement';
        case 'customer_request': return 'Customer Request';
        case 'order_modification': return 'Order Modification';
        case 'customer_didnt_reply': return 'Customer Didn\'t Reply';
        case 'delivery_zone_confusion': return 'Delivery Zone Confusion';
        case 'other': return 'Other';
        default: return '';
    }
};

const OrdersStatus = (props) => {


    const { onClose, ORDER, STORE_ID, history, location, match, onFetchSingle } = props;

    const [isLoading, setLoading] = useState(false);

    const [STATUS, setStatus] = useState(null);
    const [MESSAGE, setMessage] = useState('');
    const [REASON, setReason] = useState('');

    const [SEND_EMAIL_PROVIDER, setSendEmailProvider] = useState(false);
    const [SEND_EMAIL_CUSTOMER, setSendEmailCustomer] = useState(false);
    const [SEND_PUSH_PROVIDER, setSendPushProvider] = useState(false);
    const [SEND_PUSH_CUSTOMER, setSendPushCustomer] = useState(false);

    const onChangeStatus = async(status) => {

        if(status === 'rejected' || status === 'canceled'){
            if(REASON === 'other') {
                if(MESSAGE.length < 10){
                    swal('Message Missing', 'Please provide a detailed message for "Other" reason', 'warning');
                    return;
                }
            } else if(!REASON) {
                swal('Reason Missing', 'Please select a reason to change this order', 'warning');
                return;
            }
        }

        let final_status = STATUS;

        if(status){
            final_status = status;
        }
       

        const JWT = (typeof global.window !== 'undefined') ? localStorage.getItem('jwt_token') : null;

        setLoading(true);
  
        try{
            const messageToSend = REASON === 'other' ? MESSAGE : getReasonText(REASON);

            var DATA_RESPONSE = await postApiPrivate('/admin/orders/status', {
                id: ORDER.id,
                status: final_status,
                message: messageToSend,
                email_customer: SEND_EMAIL_CUSTOMER,
                email_provider: SEND_EMAIL_PROVIDER,
                push_customer: SEND_PUSH_CUSTOMER,
                push_provider: SEND_PUSH_PROVIDER
            } , JWT);
            
            if(DATA_RESPONSE.error){
                console.log("ERROR FROM API LOADING UPDATE STATUS", DATA_RESPONSE.error);
                setLoading(false);

                alert(DATA_RESPONSE.error);
                
                return 
            }
  
            console.log("DATA_RESPONSE ====> ", DATA_RESPONSE);
  
            setLoading(false);
            swal('Status Changed', 'Your Status has been changed successfully to ('+final_status+') !!!', 'success');
            onClose();
            
            const ORDER_ID = ORDER.id;
            if(ORDER_ID){
                onFetchSingle(ORDER_ID);
            }
  
        }
        catch(e){
            
            console.log("CREATING ===> ", e);
            setLoading(false);
        }
    }

    const onUpdateStatus = (status)=> {
        
        if(status === 'rejected' || status === 'canceled'){
            setStatus(status);
            return 
        }

        setStatus(status);
        onChangeStatus(status)
       
    }

    if(STATUS){

        return (
            <>
                <div className="slideout-wrapper active" style={{ background: '#00000040' }}>
    
                    <div className="slideout-content" style={{ color: '#000000' }}>
    
                        <div className='d-flex align-items-center justify-content-between' style={{ padding: 25 }}>
    
                            <div className="font-bold text-lg">
                                Order #{ORDER.id} - ({STATUS})
                            </div>
                            <CloseOutline color={"#000"} onClick={() => setStatus(null)} style={{ height: 30, width: 30, zIndex: 222, cursor: 'pointer' }} />
    
                        </div>
    
                        <div className="slideout-content-scroll" style={{margin: 0}}>
    
                            {isLoading ? (
                                <LoaderMaster type={'secondary'}/>
                            ) : (
                                <>
                                    <div className="d-flex flex-column pt-8 md:pb-0 pb-32">

                                        <div className="font-bold text-lg mb-5">
                                            Message/Reason - ({STATUS}) :
                                        </div>

                                        <FormControl fullWidth className="reason-form-control" style={{ width: '100%', marginBottom: '16px' }}>
                                            <InputLabel id="message-select-label">Message/Reason</InputLabel>
                                            <Select
                                                labelId="message-select-label"
                                                id="message-select"
                                                value={REASON || ''}
                                                onChange={(e) => setReason(e.target.value)}
                                                label="Message/Reason"
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        {selected === 'provider_unavailability' && <span>Provider Unavailability</span>}
                                                        {selected === 'product_unavailability' && <span>Product Unavailability</span>}
                                                        {selected === 'schedule_disagreement' && <span>Schedule Disagreement</span>}
                                                        {selected === 'customer_request' && <span>Customer Request</span>}
                                                        {selected === 'order_modification' && <span>Order Modification</span>}
                                                        {selected === 'customer_didnt_reply' && <span>Customer Didn't Reply</span>}
                                                        {selected === 'delivery_zone_confusion' && <span>Delivery Zone Confusion</span>}
                                                        {selected === 'other' && <span>Other</span>}
                                                        {!selected && <span>Select a reason</span>}
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    sx: {
                                                        zIndex: 100000,
                                                    },
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                        sx: {
                                                            zIndex: 100000,
                                                        }
                                                    },
                                                    container: document.body,
                                                    disablePortal: false,
                                                }}
                                            >
                                                <MenuItem value="provider_unavailability">Provider Unavailability</MenuItem>
                                                <MenuItem value="product_unavailability">Product Unavailability</MenuItem>
                                                <MenuItem value="schedule_disagreement">Schedule Disagreement</MenuItem>
                                                <MenuItem value="customer_request">Customer Request</MenuItem>
                                                <MenuItem value="order_modification">Order Modification</MenuItem>
                                                <MenuItem value="customer_didnt_reply">Customer Didn't Reply</MenuItem>
                                                <MenuItem value="delivery_zone_confusion">Delivery Zone Confusion</MenuItem>
                                                <MenuItem value="other">Other</MenuItem>
                                            </Select>
                                        </FormControl>

                                        {REASON === "other" && (
                                            <div style={{ marginTop: '10px', width: '100%' }}>
                                                <div className="font-bold text-sm mb-2">Custom Message:</div>
                                                <TextareaAutosize
                                                    minRows={4}
                                                    maxRows={10}
                                                    placeholder="Please provide a detailed message..."
                                                    value={MESSAGE}
                                                    style={{ width: '100%', border: 'solid 1px #00000019', borderRadius: 10, padding: 10 }}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                />
                                                {MESSAGE.length < 10 && (
                                                    <div style={{ color: '#f44336', fontSize: '12px', marginTop: '4px', width: '100%' }}>
                                                        Please enter at least 10 characters
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: 'green', color: '#ffffff', width: '100%', minHeight: 60, marginTop: 10 }} onClick={() => onChangeStatus(STATUS)}>
                                            Change Status
                                        </div>

                                        <div style={{height: 200}}></div>
                                    </div>
                                </>
                            )}
    
    
                        </div>
                        
    
                    </div>
    
                </div>
    
                
            </>
        )
    }

    return (
        <>
            <div className="slideout-wrapper active" style={{ background: '#00000040' }}>

                <div className="slideout-content" style={{ color: '#000000' }}>

                    <div className='d-flex align-items-center justify-content-between' style={{ padding: 25 }}>

                         <div className="font-bold text-lg">
                            Change Order #{ORDER.id}
                        </div>
                        <CloseOutline color={"#000"} onClick={() => onClose()} style={{ height: 30, width: 30, zIndex: 222, cursor: 'pointer' }} />

                    </div>

                    <div className="slideout-content-scroll" style={{margin: 0}}>

                        {isLoading ? (
                            <LoaderMaster type={'secondary'}/>
                        ) : (
                            <>
                                <div className="d-flex flex-column pt-8 md:pb-0 pb-32">

                                    <div className="font-bold text-lg mb-5">
                                        Order Status :
                                    </div>
                                    <div className="row justify-content-center mb-5">

                                            <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: '#9AD6AB', color: '#ffffff', width: '100%' }} onClick={() => onUpdateStatus('accepted')}>
                                            Accepted
                                            </div>

                                            <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: '#ec1529', color: '#ffffff', width: '100%' }} onClick={() => onUpdateStatus('rejected')}>
                                            Rejected
                                            </div>

                                            <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: '#88D1F1', color: '#ffffff', width: '100%' }} onClick={() => onUpdateStatus('delivering')}>
                                                Delivering
                                            </div>

                                            <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: '#ff8b3d', color: '#ffffff', width: '100%' }} onClick={() => onUpdateStatus('delivered')}>
                                                Delivered
                                            </div>

                                            <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: 'green', color: '#ffffff', width: '100%' }} onClick={() => onUpdateStatus('complete')}>
                                                Completed
                                            </div>

                                            <div className="top_add_cart simple col-sm-5 mr-sm-1" style={{ backgroundColor: '#ec1529', color: '#ffffff', width: '100%' }} onClick={() => onUpdateStatus('canceled')}>
                                                Canceled
                                            </div>
                                    </div>

                                    <div className="font-bold text-lg mb-5">
                                        Parameters :
                                    </div>
                                    <div className="flex flex-column justify-content-center">
                                        
                                        <div>
                                           <CircleSharp color={SEND_EMAIL_PROVIDER ? 'success' : 'warning'} onClick={()=> setSendEmailProvider(!SEND_EMAIL_PROVIDER)}/> Send Email to Provider
                                        </div>

                                        <div>
                                           <CircleSharp color={SEND_EMAIL_CUSTOMER ? 'success' : 'warning'} onClick={()=> setSendEmailCustomer(!SEND_EMAIL_CUSTOMER)}/> Send Email to Customer
                                        </div>

                                        <div>
                                           <CircleSharp color={SEND_PUSH_PROVIDER ? 'success' : 'warning'} onClick={()=> setSendPushProvider(!SEND_PUSH_PROVIDER)}/> Send Push to Provider
                                        </div>

                                        <div>
                                           <CircleSharp color={SEND_PUSH_CUSTOMER ? 'success' : 'warning'} onClick={()=> setSendPushCustomer(!SEND_PUSH_CUSTOMER)}/> Send Push to Customer
                                        </div>
                                           
                                    </div>

                                    <div style={{height: 200}}></div>
                                </div>
                            </>
                        )}


                    </div>
                    

                </div>

            </div>

            
        </>
    )
}

export default OrdersStatus